var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5118 10.4225C18.5118 10.942 18.074 11.36 17.5297 11.36H10.9821V17.61C10.9821 18.1275 10.5422 18.5479 9.99994 18.5479C9.45772 18.5479 9.0178 18.1295 9.0178 17.61V11.36H2.47018C1.92796 11.36 1.48804 10.9404 1.48804 10.4229C1.48804 9.90684 1.92796 9.48496 2.47018 9.48496H9.0178V3.23496C9.0178 2.71738 9.45772 2.29785 9.99994 2.29785C10.5422 2.29785 10.9821 2.71738 10.9821 3.23496V9.48496H17.5297C18.074 9.48496 18.5118 9.90684 18.5118 10.4225Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRegular);
export default __webpack_public_path__ + "static/media/plus-regular.61778a6c3fc7ca95ec51a53a7ea11bd2.svg";
export { ForwardRef as ReactComponent };